import React from "react";
import SelectFuenteInformacion from "../../selectores/SelectFuenteInformacion";
import { DescripcionFuente } from "../../funciones/FuncionesInformacion";

const CampoComboFuenteInformacion = (props) => {
  const nombre = props.nombre;
  const valor = props.valor;
  const editar = props.editar;
  const incluirNulo = props.incluirNulo;
  const estilo = props.estilo;

  const onFuenteElegida = (fuenteElegida) => {
    props.onChange(nombre, fuenteElegida);
  };

  let campo = "";
  if (editar) {
    campo = (
      <SelectFuenteInformacion
        idActual={valor}
        incluirNulo={incluirNulo}
        estilo={estilo}
        onFuenteElegida={onFuenteElegida}
      />
    );
  } else {
    campo = valor ? DescripcionFuente(valor) : "";
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoComboFuenteInformacion;
